import React from 'react'
import { TouchableOpacity, View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { useTheme } from '@ui-kitten/components'
import { StyleService, useStyleSheet } from '@style/service'
import { Icon, Text } from '@components/base'
import { useIsDarkMode } from '@config/theme'
import { NavigationProp, SyncOptionItem } from './constants'

interface SyncOptionProps {
  item: SyncOptionItem
}

export const SyncOption = ({ item }: SyncOptionProps) => {
  const styles = useStyleSheet(themedStyle)
  const theme = useTheme()
  const isDarkMode = useIsDarkMode()
  const navigation = useNavigation<NavigationProp>()

  const { label, backgroundColor, onPress } = item

  return (
    <TouchableOpacity
      style={[styles.syncOption, isDarkMode && styles.syncOptionDark]}
      onPress={() => onPress(navigation)}
      accessibilityLabel={label}
    >
      <View style={[styles.syncIcon, { backgroundColor: theme[backgroundColor] }]}>
        <Icon name="device-mobile-camera" size="14" color={theme['theme.solid.white']} />
      </View>
      <Text type="small">{label}</Text>
    </TouchableOpacity>
  )
}

const themedStyle = StyleService.create({
  syncOption: {
    alignItems: 'center',
    gap: 6,
    padding: 8,
    backgroundColor: 'theme.surface.base3',
    borderRadius: 16,
    width: 100,
  },
  syncOptionDark: {
    backgroundColor: 'theme.surface.base2',
  },
  syncIcon: {
    width: 28,
    height: 28,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
})
